import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalService } from '../../modal/modal.service';
import { SupportService } from '../../support.service';
import { SupportTicketViewModalComponent } from '../support-ticket-view-modal/support-ticket-view-modal.component';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';

@Component({
  selector: 'app-support-create-ticket-modal',
  templateUrl: './support-create-ticket-modal.component.html',
  styleUrls: ['./support-create-ticket-modal.component.scss'],
  imports: [ModalBoxComponent, FormsModule],
})
export class SupportCreateTicketModalComponent implements OnInit {
  selectedCategory = 1;
  title: string;
  description: string;
  associated: string;

  constructor(private modalService: ModalService, public supportService: SupportService) {}

  ngOnInit(): void {}

  selectCategory(categoryId: number) {
    this.selectedCategory = categoryId;
  }

  async createTicket() {
    await this.supportService.createTicket(this.selectedCategory, this.title, this.associated, this.description);

    await this.supportService.getTickets();

    this.modalService.open(SupportTicketViewModalComponent, this.supportService.tickets[0].id);
  }
}
